export default __webpack_public_path__ + "static/media/contact3.bc047d80.svg";